const initialState = {
  categories: [],
  loading: false,
  error: null
};

const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CATEGORIES':
      return {
        ...state,
        categories: action.payload,
        loading: false,
        error: null
      };
    case 'SET_CATEGORIES_LOADING':
      return {
        ...state,
        loading: action.payload
      };
    case 'SET_CATEGORIES_ERROR':
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};

export default categoriesReducer;
